import React from "react";
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import ProductShowcase from "../components/ProductShowcase";
import FAQ from "../components/FAQ";
import ClientLogos from "../components/ClientLogos";

const Home = () => {
  return (
    <div>
      <Hero />
      <ClientLogos />
      <AboutUs />
      <WhyChooseUs />
      <Testimonials />
      <Services />
      <ProductShowcase />
      <FAQ />
    </div>
  );
};

export default Home;
